<template>
	<div class="gov_headerbox" :style="isCollapse?'left: 0;width: 100%;':''">
		<div class="gov_header" :style="isCollapse?'left: 0;width: 92%;':''">
			<span class="screen" @click="onClickfoldBtn" style="z-index: 1999;" v-show="isCollapse"><i
					class="el-icon-s-unfold"></i>菜单栏</span>
			<div class="fl foldBtn" @click="onClickfoldBtn" :title="isCollapse?'展开菜单':'折叠菜单'" v-show="isCollapse"><i class="foldBtn-icon" :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i></div>
			<p class="fl lh48 ml-8" v-if="newsList.title!=''"><b class="darkred px-1 cur-pointer"
					@click="routerlinkid('/news',newsList.id,6)">最新消息：<span>{{newsList.title}}</span></b></p>
			<div class="govheaderadvtar fr por">
				<!-- <span class="fr loginout"v-if="islogin" @click="logout()" :title="userdata.username+'登出'" >登出</span> -->
				<div class="govheader_login" id="usertoken">
					<!-- {{userdata.currentCity.text}} -->
					<span class="govheader_name">{{userdata.currentCity.text}} </span>
					<span class="govheader_portrait"></span>
					<i class="el-icon-arrow-down gov_headerico"></i>
				</div> 
				<div class="gov_headermenu">
					<div class="gov_headermenu_info">
						<p class="gov_headermenu_userinfo">{{userdata.username}}<!-- <span>12345678900</span> --></p>
					</div>
					<ul>
						<li class="gov_headermenu_li" @click="routerself('/userFocus')" v-if="curWebsite.type != 6">关注领域
						</li>
						<li class="gov_headermenu_li2" @click="routerself('/baseInformation')">基本资料</li>
						<li class="gov_headermenu_li3" @click="routerself('/editPassword')" v-show="!isSmsLogin">密码修改</li>
						<li class="gov_headermenu_li4" @click="routerself('/serviceBook')"
							v-if="userdata.operatList.mkczsm.btn">服务手册</li>
						<li class="gov_headermenu_li5" @click="logout()">退出账号</li>
					</ul>
				</div>
			</div>
			<!-- 时间宽度+i 82+14 一条列表142   -->

			
			<p class="fr lh48 mr-3" v-if="curWebsite.type != 7 && curWebsite.type != 8 && userdata.remainDays>0" v-show="userdata.remainDays<30">
				本账号有效截止到<span class="darkred px-1">{{userdata.endDate}}</span>，还剩<span class="darkred px-1">{{userdata.remainDays}}</span>天， 如需延期<a class="darkred" href="https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true" target="_blank">请咨询 &gt;</a>
			</p>
			<p class="fr lh48 mr-3" v-if="curWebsite.type != 7 && curWebsite.type != 8 && userdata.remainDays<0">本账号试用期已截止，如需延期<a class="darkred" href="https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true" target="_blank">请咨询 &gt;</a>></p>
			<div class="fr" v-show="dynamicListnum.length>0">
				<h5 class="dynamic_scroll_title fl">动态监测</h5>
				<div class="gheader_dynamic fl" ref="container">
					<ul class="gheader_dynamic_line" ref="list"
						:style="{transform: 'translateX(' + dynamicMovepostion + 'px)',width:dynamicWidth+'px'}"
						@mouseenter="timeClockBtn=false" @mouseleave="timeClockBtn=true">

						<li class="gheader_dynamic_a" v-for="(list,i)  in dynamicListnum" :key="i">
							<i v-if="i>0">|</i>
							<strong>{{list.date}}</strong>
							<span :key="index" v-for="(item,index) in list.children"
								v-if=" item.type!=3 && item.title!=''"
								:class="item.isRead<1?'current dy_onelnenews':'dy_onelnenews' "
								@click="trunDynamicUrl(item.urls)">新增{{item.num}}条{{item.title}}</span>
						</li>
					</ul>
				</div>
			</div>

			<video-teaching v-if="showVideo" :type="videoType" seat="top" style="line-height: 48px;"></video-teaching>
		</div>
	</div>
</template>

<script>
	import $ from "jquery";
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'govheader',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		isSmsLogin: (state) => state.isSmsLogin,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				//usern.edition 判断是否为普通或完整版本  user.groupType 判断为试用账户还是全开用户 
				isopen: false,
				islogin: false,
				ischange: false,
				timerClock: null,
				timeClockBtn: true,
				dynamicMovepostion: 0,
				userdata: {
					currentCity: {
						text: ""
					},
					operatList: {
						mkczsm: false
					},
					token: ""
				},
				userdat: {},
				crmuserdata: {},
				dynamicListnum: [],
				dynamicWidth: 0,
				curWebsite: this.$api.getWebsiteType(),
				testDynamic: [{
						"id": 23362,
						"date": "2023-08-14",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 13,
						"isRead": 0
					},
					{
						"id": 23360,
						"date": "2023-08-14",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 37,
						"isRead": 0
					},
					{
						"id": 23394,
						"date": "2023-08-14",
						"type": 5,
						"typeText": "企业资讯",
						"num": 6,
						"isRead": 0
					},
					{
						"id": 23395,
						"date": "2023-08-13",
						"type": 5,
						"typeText": "企业资讯",
						"num": 12,
						"isRead": 0
					},
					{
						"id": 23361,
						"date": "2023-08-12",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 3,
						"isRead": 0
					},
					{
						"id": 23349,
						"date": "2023-08-11",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 17,
						"isRead": 0
					},
					{
						"id": 23350,
						"date": "2023-08-11",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 55,
						"isRead": 0
					},
					{
						"id": 23351,
						"date": "2023-08-11",
						"type": 4,
						"typeText": "招商情报实时动态",
						"num": 1,
						"isRead": 0
					},
					{
						"id": 23352,
						"date": "2023-08-10",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 11,
						"isRead": 0
					},
					{
						"id": 23353,
						"date": "2023-08-10",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 110,
						"isRead": 0
					},
					{
						"id": 23354,
						"date": "2023-08-10",
						"type": 4,
						"typeText": "招商情报实时动态",
						"num": 4,
						"isRead": 0
					},
					{
						"id": 23355,
						"date": "2023-08-10",
						"type": 5,
						"typeText": "企业资讯",
						"num": 13,
						"isRead": 0
					},
					{
						"id": 23050,
						"date": "2023-08-09",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 12,
						"isRead": 0
					},
					{
						"id": 23356,
						"date": "2023-08-09",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 111,
						"isRead": 0
					},
					{
						"id": 23097,
						"date": "2023-08-09",
						"type": 5,
						"typeText": "企业资讯",
						"num": 15,
						"isRead": 0
					},
					{
						"id": 22849,
						"date": "2023-08-08",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 16,
						"isRead": 0
					},
					{
						"id": 23357,
						"date": "2023-08-08",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 161,
						"isRead": 0
					},
					{
						"id": 22850,
						"date": "2023-08-08",
						"type": 4,
						"typeText": "招商情报实时动态",
						"num": 3,
						"isRead": 0
					}
				],
				dynamicurl: ["/investdynamic", "/landdynamic", "/enterpriseNews1", "/timeinfor", "/enterpriseNews", ],
				newsList: {title:''},
			}
		},
		props: {
			showVideo: {
				required: false,
				default: false,
			},
			videoType: {
				required: false,
				default: 4,
			},
		},
		watch: {
			curindex: {
				handler(newValue, oldValue) {
					this.type = newValue;
					$('.headr-nav-li').eq(this.curindex).addClass('current').siblings('.headr-nav-li').removeClass(
						'current');
				}
			},
		},
		created() {
			this.userdata = this.getuseriformation();
		},
		mounted() {
			// this.getuserinfor();  
			if (this.userdata) {
				this.getdynamicNotify();
				this.getUserMessage();
			} else {
				this.userdata = this.getuseriformation();
				this.getdynamicNotify();
				this.getUserMessage();
			}
		},
		methods: {
			...mapMutations({
				set_collapse: "SET_COLLAPSE"
			}),
			//折叠菜单
			onClickfoldBtn() {
				console.log('点击展开收起',this.isCollapse)
				this.set_collapse(!this.isCollapse)
			},
			//动态消息展示
			getUserMessage() {
				var that = this;
				this.$axios.get(this.$api.cyl.userMessage.latest(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log('动态消息展示govhearder',res); 
					if (res.data.success) {
						that.newsList = res.data.data||{title:''};
						// that.newsList=res.data.list;
					}
				})
			},
			//动态监测实时滚动
			dynamicTimer() {
				// console.log(this.$refs.list.offsetWidth,this.dynamicWidth);
				this.timerClock = setInterval(() => {
					if (this.timeClockBtn) {
						let newPosition = this.dynamicMovepostion - 1;
						if (newPosition < -(this.dynamicWidth - 100)) {
							newPosition = 0;
						}
						this.dynamicMovepostion = newPosition;
					}
				}, 50);
			},
			// getuserinfor(){
			// 	let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
			// 	if(typeof(dataddd) == 'object'){
			// 	this.userdata = dataddd;
			// 	}else{
			// 	this.userdata = JSON.parse(dataddd);
			// 	}  ;
			// 	console.log('voheader.this.userdata',this.userdata)
			// 	if(this.userdata.token && this.userdata.token.length>0){
			// 		this.getdynamicNotify();  
			// 	}else{
			// 		console.log('token拿不到',this.userdata);
			// 	}

			// },
			//获取动态监测列表
			getdynamicNotify() {
				var _this = this;
				// console.log('this.userdata.token',this.userdata.token);
				return;
				this.$axios.get(this.$api.cyl.dynamicNotify.list(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log('获取动态监测实时列表a',res.data);
					if (res.data.success) {
						_this.ischange = res.data.data.isChange;
						var listg = res.data.list;
						var urlbox = [{
									type: 1,
									title: '投资项目动态',
									url: '/investdynamic'
								},
								{
									type: 2,
									title: '拿地项目动态',
									url: "/landdynamic",
								},
								{
									type: 3,
									title: "企业投资动态",
									url: "/enterpriseNews1",
								},
								{
									type: 4,
									title: '招商情报动态',
									url: "/timeinfor",
								},
								{
									type: 5,
									title: '企业资讯动态',
									url: "/enterpriseNews",
								},
								{
									type: 6,
									title: '融资项目动态',
									url: "/financingdynamic",
								},
								{
									type: 7,
									title: '产业资讯动态',
									url: "/industryInvestment",
								},
							],
							smlist = [];
						if (_this.curWebsite.type == 4) {
							urlbox = [{
									type: 1,
									title: '投资项目动态',
									url: '/investdynamic'
								},
								{
									type: 2,
									title: '拿地项目动态',
									url: "/landdynamic",
								},
								{
									type: 3,
									title: "企业投资动态",
									url: "/enterpriseNews1",
								},
								{
									type: 4,
									title: '市场情报动态',
									url: "/timeinfor",
								},
								{
									type: 5,
									title: '',
									url: "/enterpriseNews",
								},
								{
									type: 6,
									title: '融资项目动态',
									url: "/financingdynamic",
								},
							]
						} else if (_this.curWebsite.type == 6 || _this.curWebsite.type == 5) {
							urlbox = [{
									type: 1,
									title: '上市公司投资动态',
									url: '/markenterprise'
								},
								{
									type: 2,
									title: '企业拿地投资动态',
									url: "/landenterprise",
								},
								{
									type: 3,
									title: "",
									url: "/enterpriseNews1",
								},
								{
									type: 4,
									title: '',
									url: "/timeinfor",
								},
								{
									type: 5,
									title: '',
									url: "/enterpriseNews",
								},
								{
									type: 6,
									title: '',
									url: "/financingdynamic",
								},
								{
									type: 7,
									title: '产业资讯动态',
									url: "/industryInvestment",
								},
							]
						}
						var datelist = [{
							date: listg[0].date,
							children: []
						}];
						var width1 = 96,
							width2 = 0,
							width3 = 0;
						for (var i = 0; i < listg.length; i++) {
							width2 += 152;
							var l = datelist.length - 1;
							var x = listg[i].type - 1;
							listg[i].urls = urlbox[x].url;
							listg[i].title = urlbox[x].title;
							if (listg[i].date == datelist[l].date) {
								datelist[l].children.push(listg[i]);
							} else {
								width1 += 96;
								datelist.push({
									date: listg[i].date,
									children: [listg[i]]
								});
							}
						}
						width3 = width1 + width2 - 40;
						_this.dynamicWidth = width3;
						// console.log('datelist',datelist);
						_this.dynamicListnum = datelist;
						if (datelist.length > 0) {
							_this.dynamicTimer();
						}

					} else {

					}
				}).catch(function(error) {
					// 请求失败处理
					// console.log(error);
				});
			},
			//点击取消阅读 跳转页面
			trunDynamicUrl(urls) {
				var _this = this;
				this.$axios.get(this.$api.cyl.dynamicNotify.read(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log("crm",res);
					if (res.data.success) {
						_this.routerself(urls);
					} else {

					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			}
		},
	}
</script>

<style>
	/* @import url("../../css/entercss.css");  */
	@import url("../../css/headfoot.css");
</style>